import {h, Fragment} from "preact"
import { useAppState } from "@nosto/preact"
import { useEffect } from 'preact/hooks'

export default function NoResults() {
    const {
        response: { query }
    } = useAppState()

    useEffect(() => {
        nostojs(api => {
            api.createRecommendationRequest({
            includeTagging: true
            })
            .setElements(["searchpage-nosto-2"])
            .loadRecommendations()
        })
    },[])

    return (
        <>
            <div class="nosto-rec-container">
                <div class="nosto_element" id="searchpage-nosto-2"></div>
            </div>
            <div class="ns-noresult-container ns-text-align-center ns-my-5 ns-mx-0">
                <div class="ns-noresult-text">Please try another search term...</div>
            </div>
        </>
    )
}
